import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-vue-nav-reports",
  "use": "foquz-icon-vue-nav-reports-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-vue-nav-reports\"><path d=\"M11 16v-2m3 2v-1m3 1v-4M6 6L4 8m1 11h14a2 2 0 002-2V7a2 2 0 00-2-2H9v4a2 2 0 01-2 2H3v6a2 2 0 002 2z\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol